import { Dice5Icon } from './Dice5Icon';

/**
 * author: Yasmina Lembachar
 * id 9B9F7FE0-5AA9-4B5F-B865-D7F21C1382AF
 * name dice-5
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-5.svg
 * tags
 * - Gaming / RPG 
 */
export const Die5Icon = Dice5Icon;
export default Die5Icon